module.exports = __webpack_public_path__ + "static/js/2.c9d435a9.chunk.worker.js"